<template>
  <div class="tc-legend">
    <div class="tc-legend__toggle">
      <div
        :class="[isLegendActive ? 'active' : '', 'tc-legend__button legend']"
        @click="toggleLegend"
      >
        <r-icon name="help" :size="20" :active="isLegendActive" />
      </div>
    </div>

    <div class="tc-legend-content" v-if="isLegendActive">
      <ul class="tc-legend-list">
        <li class="tc-legend-tc-item">
          <div class="tc-legend-tc-key cp-label">
            <div class="tc-legend-cp-label forward">25 <span>▶</span></div>
            <div class="tc-legend-tc-count-point"></div>
            <div class="tc-legend-cp-label backward"><span>◀</span> 24</div>
          </div>
          <!-- <span class="tc-legend-tc-separator">-</span> -->
          <div class="tc-legend-tc-value">
            Общее количество ТС, проехавших по подходу: вперед (сверху) и назад
            (снизу)
          </div>
        </li>
        <li class="tc-legend-tc-item">
          <div class="tc-legend-labels">
            <div class="tc-legend-labels-header">
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key"></div>
                <div class="tc-legend-label-value">
                  Общее количество ТС, разбитое по категориям:
                </div>
              </div>
            </div>
            <div class="tc-legend-labels">
              <div class="tc-legend-labels-line" />
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key C">
                  10
                </div>
                <div class="tc-legend-label-value">
                  легковые (C)
                </div>
              </div>
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key G">
                  20
                </div>
                <div class="tc-legend-label-value">
                  грузовые (G)
                </div>
              </div>
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key B">
                  30
                </div>
                <div class="tc-legend-label-value">
                  автобусы (B)
                </div>
              </div>
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key T1">
                  20
                </div>
                <div class="tc-legend-label-value">
                  троллейбус (T1)
                </div>
              </div>
              <div class="tc-legend-label-row">
                <div class="tc-legend-label-key T2">
                  10
                </div>
                <div class="tc-legend-label-value">
                  трамвай (T2)
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["is-legend-active"],
  methods: {
    toggleLegend() {
      this.$emit("toggle-legend");
    }
  }
};
</script>

<style lang="scss">
.tc-legend {
  position: absolute;
  right: 16px;
  top: 176px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;

  &__toggle {
    color: var(--text_primary) !important;
    background-color: var(--modal_bg) !important;
    border-radius: 4px;
  }

  &__button {
    border-radius: 4px;
    width: 36px;
    height: 36px;
    cursor: pointer;

    &.active {
      background-color: rgba(var(--accent_primary), 0.3) !important;
    }
  }

  &-content {
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    width: 240px;
    z-index: 1000;
    font-size: 12px;
    color: var(--white_white);
    user-select: none;
    margin-top: 8px;

    background-color: var(--modal_bg) !important;
    border-color: var(--dividers_low_contrast) !important;
  }

  &-list {
    padding: 10px;
    overflow: auto;
    max-height: calc(100vh - 293px);
  }

  &-tc-item:not(:last-child) {
    margin-bottom: 20px;
  }

  &-tc-item {
    display: flex;
  }

  &-tc-key {
    flex-shrink: 0;
    width: 20%;

    &.cp-label {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &-tc-value {
    margin-left: 8px;
    color: var(--text_secondary) !important;
  }

  &-labels {
    width: 100%;
    position: relative;

    &-line {
      position: absolute;
      background-color: rgb(255, 68, 140);
      width: 2px;
      height: 100%;
      left: 17px;
      top: 0;
      z-index: 0;

      &:before {
        content: "";
        position: absolute;
        border: 4px solid transparent;
        border-top: 6px solid rgb(255, 68, 140);
        bottom: -9px;
        left: -3px;
        z-index: 1;
      }
    }
  }

  &-label {
    width: 100%;

    &-row {
      display: flex;
      width: 100%;
    }

    &-key {
      width: 20%;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
      z-index: 10;
      flex-shrink: 0;
      text-shadow: -0 -1px 0 #242730, 0 -1px 0 #242730, -0 1px 0 #242730,
        0 1px 0 #242730, -1px -0 0 #242730, 1px -0 0 #242730, -1px 0 0 #242730,
        1px 0 0 #242730, -1px -1px 0 #242730, 1px -1px 0 #242730,
        -1px 1px 0 #242730, 1px 1px 0 #242730, -1px -1px 0 #242730,
        1px -1px 0 #242730, -1px 1px 0 #242730, 1px 1px 0 #242730;

      &.C {
        color: rgba(85, 183, 126, 1);
      }
      &.G {
        color: rgba(145, 94, 255, 1);
      }
      &.B {
        color: rgba(255, 76, 141, 1);
      }
      &.T1 {
        color: rgba(248, 195, 72, 1);
      }
      &.T2 {
        color: rgba(229, 101, 102, 1);
      }
    }

    &-value {
      margin-left: 8px;
      color: var(--text_secondary) !important;
    }
  }

  &-tc-count-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid #fff;
    background-color: #55b77e;
    margin-top: 4px;
    margin-bottom: 3px;
  }

  &-cp-label {
    font-size: 11px;
    color: #55b77e;
    display: flex;
    align-items: center;
    font-weight: bold;
    // text-shadow: -0 -1px 0 #242730, 0 -1px 0 #242730, -0 1px 0 #242730,
    //   0 1px 0 #242730, -1px -0 0 #242730, 1px -0 0 #242730, -1px 0 0 #242730,
    //   1px 0 0 #242730, -1px -1px 0 #242730, 1px -1px 0 #242730,
    //   -1px 1px 0 #242730, 1px 1px 0 #242730, -1px -1px 0 #242730,
    //   1px -1px 0 #242730, -1px 1px 0 #242730, 1px 1px 0 #242730;

    &.forward span {
      margin-left: 2px;
    }
    &.backward span {
      margin-right: 2px;
    }

    span {
      font-size: 6px;
      vertical-align: middle;
    }
  }

  &-turn-label {
    font-size: 10px;
    color: #000;
    display: flex;
    position: relative;
    transform-origin: top left;
    text-shadow: -0 -1px 0 #ffffff, 0 -1px 0 #ffffff, -0 1px 0 #ffffff,
      0 1px 0 #ffffff, -1px -0 0 #ffffff, 1px -0 0 #ffffff, -1px 0 0 #ffffff,
      1px 0 0 #ffffff, -1px -1px 0 #ffffff, 1px -1px 0 #ffffff,
      -1px 1px 0 #ffffff, 1px 1px 0 #ffffff, -1px -1px 0 #ffffff,
      1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;

    &:before {
      content: "";
      width: calc(100% + 10px);
      height: 2px;
      position: absolute;
      top: 50%;
      background-color: rgb(255, 68, 140);
      margin-left: -5px;
      z-index: -1;
    }
  }

  &-tc-separator {
    margin: 0 10px;
  }
}
</style>
